<template>
  <div class="login">
    <TopNav class="top-show" title="登录/注册"></TopNav>

    <img class="bg" src="../assets/images/img_01_bg.png" alt="" />

    <div class="w-1200">
      <van-image :src="logAI" class="logo" />

      <div class="log-pc">
        <img src="../assets/images/img_logo.png" alt="" />
        <p>
          一款最前沿的大语言模型，支持AI写作、文案创意、智能连续对话的AI机器人
        </p>
      </div>

      <div class="card">
        <transition name="van-slide-left">
          <div class="transition-box" v-show="step == 1">
            <div class="title-top">手机号登录</div>
            <FormVant @onSubmit="onSubmit" class="form-absolute">
              <div class="columns-box">
                <van-field
                  v-model="form.mobile"
                  name="mobile"
                  class="mobile parent"
                  @focus="changeParentColor"
                  @blur="changeParentColor"
                  :border="false"
                  placeholder="请输入手机号"
                  autocomplete="off"
                >
                  <template #label>
                    <!-- 替换为一个头像 -->
                    <div class="columns-code" @click.stop="isWidth()">
                      +{{ form.area_code }}
                      <svg-icon
                        className="arrow-down"
                        iconClass="mini_arrow_down"
                      ></svg-icon>
                    </div>
                  </template>
                </van-field>
                <transition name="dropdown">
                  <ul
                    class="columns-ul scroll-transparent"
                    v-show="showPickerPC"
                  >
                    <li
                      v-for="item in columns"
                      :key="item.en"
                      :class="{ select: locale == item.locale }"
                      @click="onColumns(item)"
                    >
                      {{ item.zh }}+{{ item.code }}
                    </li>
                  </ul>
                </transition>
              </div>
              <van-field
                v-model="form.vcode"
                type="digit"
                name="code"
                class="code parent"
                @focus="changeParentColor"
                @blur="changeParentColor"
                :border="false"
                placeholder="请输入验证码"
                autocomplete="off"
                label-width="0px"
              >
                <template #button>
                  <van-image
                    width="78"
                    height="28"
                    :src="codeurl"
                    class="image"
                    @click="updateCode"
                  />
                </template>
              </van-field>
              <div class="agreement">
                <svg-icon
                  @click.native="switchover"
                  className="agreement-icon"
                  :iconClass="checkbox"
                ></svg-icon>
                <div class="agreement-box">
                  勾选即同意
                  <div
                    @click="isProtocol('web_service')"
                    class="agreement-content"
                  >
                    《用户协议》
                  </div>
                  与
                  <div
                    target="_blank"
                    @click="isProtocol('web_private')"
                    class="agreement-content"
                  >
                    《隐私政策》
                  </div>
                </div>
              </div>
              <van-button
                round
                block
                :disabled="btnSubmit"
                :loading="loading"
                type="info"
                class="log-btn"
                :color="btnColor"
                :style="{'opacity': btnSubmit ? '.5' : '1'}"
                native-type="submit"
                loading-text="获取中..."
                >获取验证码</van-button
              >
            </FormVant>
          </div>
        </transition>

        <transition name="van-slide-right">
          <div class="transition-box" v-show="step == 2">
            <img
              class="back-img"
              @click="toback()"
              src="../assets/images/ic_left.png"
              alt=""
            />
            <div class="title-top">输入短信码</div>
            <div class="title-prompt">
              短信验证码已发送至+{{ form.area_code }}&nbsp;{{ form.mobile }}
            </div>
            <security-code
              class="security"
              @inputEnd="onInputEnd"
              ref="security"
              :length="6"
              placeholder=""
              v-model="form.code"
            ></security-code>
            <div
              class="reacquire"
              :class="{ disabled: disabled }"
              @click="codeSubmit(true)"
            >
              {{ codeText }}
            </div>
            <van-button
              round
              block
              :disabled="btnSubmit"
              :loading="login_loading"
              type="info"
              :color="btnColor"
              class="log-btn"
              @click="onInputEnd"
              loading-text="登录中..."
              >确定</van-button
            >
            <!-- <van-button round block :loading="login_loading" type="info" color="linear-gradient(90deg, #C3DF48 0%, #80F4FF 100%)" class="" @click="onInputEnd" loading-text="登录中...">确定</van-button> -->
          </div>
        </transition>
      </div>
    </div>

    <Popup v-model="showPicker" round position="bottom" class="columns-pop">
      <ul class="columns-ul scroll-transparent">
        <li
          v-for="item in columns"
          :key="item.en"
          :class="{ select: locale == item.locale }"
          @click="onColumns(item)"
        >
          {{ item.zh }}+{{ item.code }}
        </li>
      </ul>
    </Popup>

    <Popup v-model="showCode" round class="code-pop" title="输入验证码">
      <img
        class="off-img"
        @click="showCode = false"
        :src="closeImg"
      />
      <FormVant class="form-absolute">
        <div class="flex-c code-retry">
          <van-field
            v-model="form.vcode"
            type="digit"
            name="code"
            class="code parent"
            @focus="changeParentColor"
            @blur="changeParentColor"
            :border="false"
            placeholder="请输入验证码"
            autocomplete="off"
            label-width="0px"
          />
          <van-image
            width="78"
            height="28"
            :src="codeurl"
            class="image m-m-l-12"
            @click="updateCode"
          />
        </div>
        <div class="flex-c btn-box">
          <van-button
            round
            block
            type="info"
            color="#1A3D5A"
            class="btns"
            @click="showCode = false"
            >取消</van-button
          >
          <van-button
            round
            block
            :loading="login_loading"
            type="info"
            color="linear-gradient(90deg, #C3DF48 0%, #80F4FF 100%)"
            class="btns"
            @click="codeSubmit(true)"
            loading-text="登录中..."
            >确定</van-button
          >
        </div>
      </FormVant>
    </Popup>
  </div>
</template>

<script>
import TopNav from "../components/TopNav.vue";
import FormVant from "../components/FormVant.vue";
import SecurityCode from "../components/SecurityCode.vue";
import columns from "../assets/data/mobileCodeData.json";
import Popup from "../components/Popup.vue";
import {getAPI} from "../assets/js/tools";

export default {
  name: "Login",
  components: {
    TopNav,
    FormVant,
    SecurityCode,
    Popup,
  },
  props: {
    isPop: Boolean,
    closeImg: {
      type: String,
      default: require('../assets/images/ic_close.png')
    }
  },
  data() {
    return {
      path: this.$route.query.path,
      continue: this.$route.query.continue, // 后台进入本页面
      step: 1, // 步骤
      locale: "CN", // 手机号地区
      columns: columns, // 引入手机区域文件
      showPicker: false, // 选择手机区域弹窗控制
      showPickerPC: false, // 选择手机区域弹窗控制PC
      showCode: false, // 重新输入验证码弹窗控制
      codeurl: "", // 图片验证码
      checkbox: "checkbox_circle_nor", // 协议按钮cvg昵称切换
      btnColor: "linear-gradient(90deg, #C3DF48 0%, #80F4FF 100%)", // 按钮背景
      checkboxSelect: false, // 是否勾选协议
      form: {
        // 获取验证码的表单元素
        mobile: "",
        vcode: "",
        code: "", // 短信验证码
        area_code: "86",
        key: Math.random(),
      },
      codeText: "重新获取",
      timer: null, // 重新获取时间计时器
      secondCount: 60, // 倒计时总数
      seconds: 0, // 倒计时
      disabled: false, // 是否可以重新获取验证码
      loading: false,
      login_loading: false,

      logAI: require("../assets/images/img_logo_AI.png"),

      iosAgreement: "",
      androidAgreement: "",
    };
  },
  computed: {
    btnSubmit() {
      // 按钮是否可以点击
      let stepOne =
        this.step == 1 &&
        this.checkboxSelect &&
        this.form.mobile &&
        this.form.vcode;
      let stepTwo = this.step == 2 && this.form.code.length >= 6;

      if (stepOne || stepTwo) {
        // this.btnColor = "linear-gradient(90deg, #C3DF48 0%, #80F4FF 100%)";
        return false;
      }

      // this.btnColor = "linear-gradient(90deg, #61783F 0%, #40839A 100%)";
      return true;
    },
    currentRoute() {
      return this.$store.state.currentRoute;
    },
    weixinLoginToken() {
      return this.$store.state.weixinLoginToken;
    },
    user() {
      return this.$store.state.user;
    },
    distribution() {
      return this.$store.state.distribution;
    },
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    /** 对input获取焦点后添加样式
     * @param e 获取焦点的input元素
     */
    changeParentColor(e) {
      if (window.innerWidth <= 768) {
        return false;
      }
      var clickedElement = e.target; // 获取到input元素
      var parentElement = clickedElement.closest(".parent"); // 获取到被点击元素的父元素

      if (!parentElement) return false;

      if (parentElement.classList.contains("focus")) {
        parentElement.classList.remove("focus");
      } else {
        parentElement.classList.add("focus");
      }
    },
    isWidth() {
      if (window.innerWidth <= 768) {
        this.showPicker = !this.showPicker;
      } else {
        this.showPickerPC = !this.showPickerPC;
      }
    },
    isProtocol(type) {
        // this.$router.push({name: 'Protocol', query: {type: type}})
        window.open(
          this.getServer() + "/chat/protocol?type=" + type,
          "_blank"
        );
    },
    // 返回到第一步
    toback() {
      this.form.vcode = "";
      // this.form.code = "";
      this.$set(this.form, "code", "");
      this.updateCode();
      clearInterval(this.timer);
      this.storage.remove("timestamp");
      this.step = 1;
    },
    onSubmit(values) {
      const reg = /^1[3-9][0-9]\d{8}$/;
      if (!reg.test(values.mobile)) {
        this.$toast("手机号错误");
        return false;
      }

      this.codeSubmit();
    },
    onColumns(item) {
      this.locale = item.locale;
      this.form.area_code = item.code;
      this.showPicker = false;
      this.showPickerPC = false;
    },
    updateCode() {
      this.form.key = Math.random();
      this.codeurl =
        this.getAPI() + "/api/imageCode?key=" + this.form.key;
      console.log(this.codeurl);
    },
    codeSubmit(is) {
      if (this.isCountdown()) {
        this.step = 2;
        this.setTimerChange(); //立刻执行一次
        clearInterval(this.timer);
        this.timer = setInterval(this.setTimerChange, 1000);
        this.$toast("请稍后获取验证码");
        this.$refs.security.focusInput();
        return false;
      }

      if (this.seconds < this.secondCount && this.seconds > 0) return false;

      let qsData = {
        mobile: this.form.mobile,
        vcode: this.form.vcode,
        event: "login",
        key: this.form.key,
      };
      this.loading = true;
      this.$axios
        .post("/api/sendPhoneCode", this.$qs.stringify(qsData))
        .then((res) => {
          this.loading = false;
          let result = res.data;

          if (result.errorno) {
            this.updateCode();
            this.form.vcode = "";
            if (is) {
              if (this.showCode) {
                this.$toast("验证码错误");
              }
              this.showCode = true;
            } else {
              this.$toast(result.error);
            }
            return;
          }
          this.showCode = false;
          if (result.state == "success") {
            if (!this.isCountdown()) {
              this.storage.set(
                "timestamp",
                Math.floor(Date.now() / 1000) + this.secondCount
              );
            }

            this.setTimerChange(); //立刻执行一次
            clearInterval(this.timer);
            this.timer = setInterval(this.setTimerChange, 1000);

            this.step = 2;
            this.$refs.security.focusInput();
          }
        });
    },
    onInputEnd() {
      let qsData = {
        mobile: this.form.mobile,
        code: this.form.code,
        area_code: this.form.area_code,
      };
      if (this.$tools.isWeixinClient()) {
        qsData.weixin_login_token = this.weixinLoginToken;
      }
      this.login_loading = true;
      return this.$axios
        .post("/login/loginbymobile", this.$qs.stringify(qsData))
        .then((res) => {
          this.login_loading = false;
          let result = res.data;
          if (result.errorno == "300002") {
            this.$toast(result.error);
            return;
          }

          if (result.errorno) {
            // this.$toast(result.error);
            return;
          }

          if (result.state == "success") {
            clearInterval(this.timer);
            this.storage.remove("timestamp");
            this.updataInfo();
          }
        });
    },
    async updataInfo() {
      this.isToken();
      let localCurrentRoute = JSON.parse(this.storage.get("currentRoute"));

      await this.updateUserInfo();
      if (
        (localCurrentRoute && localCurrentRoute.meta.distr) ||
        (this.currentRoute && this.currentRoute.meta.distr)
      ) {
        await this.updateDistributionInfo();
      }

      this.isHistoryUrl();
    },
    cleartimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    setTimerChange() {
      if (this.seconds <= 0) {
        this.cleartimer();
        this.disabled = false;
        this.seconds = this.secondCount;
        this.codeText = "重新获取";
        return false;
      }

      this.seconds--;
      this.codeText = "重新获取(" + this.seconds + "s)";
      this.disabled = true;
    },
    switchover() {
      if (this.checkboxSelect) {
        this.checkboxSelect = false;
        this.checkbox = "checkbox_circle_nor";
      } else {
        this.checkboxSelect = true;
        this.checkbox = "checkbox_circle_sel";
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        // 计算剩余倒计时时间
        if (this.isCountdown()) {
          this.setTimerChange(); //立刻执行一次
          this.timer = setInterval(this.setTimerChange, 1000);
        }
      } else {
        // 当页面不可见时，清除定时器
        this.cleartimer();
      }
    },
    isCountdown() {
      let currentTime = Math.floor(Date.now() / 1000);
      const storedTimestamp = this.storage.get("timestamp");
      if (storedTimestamp) {
        const elapsedSeconds = storedTimestamp - currentTime;
        if (elapsedSeconds > 0 && elapsedSeconds < this.secondCount) {
          this.seconds = elapsedSeconds;
          return true;
        }

        this.seconds = this.secondCount;
        return false;
      } else {
        this.seconds = this.secondCount;
        return false;
      }
    },
    isHistoryUrl() {
      // 弹窗状态
      if (this.isPop) {
        // this.$emit('click')
        location.reload();
        return false;
      }

      if (this.continue) {
        location.href = decodeURIComponent(this.continue);
        return false;
      }

      let localCurrentRoute = JSON.parse(this.storage.get("currentRoute"));
      this.storage.remove("currentRoute");

      if (
        (localCurrentRoute && localCurrentRoute.meta.distr) ||
        (this.currentRoute && this.currentRoute.meta.distr)
      ) {
        if (
          !this.distribution &&
          localCurrentRoute &&
          localCurrentRoute.name != "Extend" &&
          localCurrentRoute &&
          localCurrentRoute.name != "PromoteVip"
        ) {
          if (
            (this.currentRoute && this.currentRoute.name == "Become") ||
            (localCurrentRoute && localCurrentRoute.name == "Become")
          ) {
            this.$router.push(this.currentRoute || localCurrentRoute);
            return false;
          }
          this.$router.push("/become");
          return false;
        }

        if (this.currentRoute) {
          this.$router.push(this.currentRoute);
          return false;
        }

        this.$router.push("/home");
      } else {
        if (this.currentRoute || localCurrentRoute) {
          this.$router.push(this.currentRoute || localCurrentRoute);
          return false;
        }

        this.$router.push("/");
      }
    },
    isShow() {
      if (window.innerWidth <= 768) {
        this.showPicker = false;
      } else {
        this.showPickerPC = false;
      }
    },
  },
  created() {
    if (this.token) {
      this.isHistoryUrl();
    }
    this.updateCode();

    document.documentElement.style.height = "100%";
    document.body.style.height = "100%";
    document.getElementById('app').style.height = "100%";

  },
  mounted() {
    window.addEventListener("click", this.isShow);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("click", this.isShow);
  },
};
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.login {
  background: #001235;
  overflow: hidden;
  height: 100%;
  position: relative;

  .bg {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    height: 100%;
    transform: translateX(-50%);
  }
}

.top-show {
  display: none;
}

.w-1200 {
  width: 1200px;
  height: 100%;
  align-items: center;
  margin: 0 auto;
  display: flex;

  .logo {
    display: none;
  }

  .log-pc {
    position: relative;
    flex-shrink: 0;

    img {
      // width: 310px;
      height: 98px;
    }

    p {
      font-size: 28px;
      color: #e6e9ed;
      font-weight: lighter;
      max-width: 640px;
      margin-top: 31px;
    }
  }
}

.card {
  margin-left: auto;
  position: relative;
  width: 400px;
  background: #001235;
  border-radius: 16px;
  min-height: 362px;
  overflow: hidden;

  .transition-box {
    padding: 32px;
    width: 100%;
    position: absolute;
    top: 0;

    .columns-box {
      position: relative;

      .columns-ul {
        position: absolute;
        width: 336px;
        background: #002748;
        border-radius: 8px;
        max-height: 140px;
        overflow: hidden;
        overflow-y: auto;
        padding: 8px;
        top: calc(100% + 12px);
        z-index: 2;

        li {
          height: 40px;
          line-height: 48px;
          padding: 0 16px;
          font-size: 16px;
          color: #e6e9ed;
          cursor: pointer;

          &.select {
            color: #00e3f9;
          }

          &:hover {
            background: #1a3d5a;
          }
        }
      }

      .dropdown-enter-active,
      .dropdown-leave-active {
        transition: all 0.5s;
      }

      .dropdown-enter,
      .dropdown-leave-to {
        opacity: 0;
        transform: translateY(-20px);
      }
    }

    .back-img {
      width: 22px;
      height: 22px;
      margin-bottom: 32px;
      cursor: pointer;
    }

    .title-top {
      color: #e6e9ed;
      font-size: 24px;
    }

    .reacquire {
      margin: 12px 0 29px;
      color: #00e3f9;
      font-size: 14px;

      &.disabled {
        // color: #0085a0;
        opacity: .5;
      }
    }

    .security {
      /deep/ .security-code-container {
        .field-wrap {
          font-size: 18px;
          width: 48px;
          height: 48px;
          background: #001235;
          border-color: #1a3d5a;

          &.cursor {
            border-color: #00e3f9;

            &::after {
              width: 2px;
            }
          }

          &.cursorLast {
            border-color: #00e3f9;
          }
        }
      }
    }

    .log-btn {
      height: 48px;
      font-size: 18px;
      color: #001235 !important;
      font-weight: bold;
    }

    .title-prompt {
      color: #989fad;
      font-size: 16px;
      margin: 8px 0 24px;
    }

    .form-absolute {
      margin-top: 24px;

      .van-cell {
        background: #001235;
        border-color: #1a3d5a;
        height: 60px;
        font-size: 16px;
        margin-bottom: 16px;
      }

      .columns-code {
        color: #e6e9ed;
        cursor: pointer;

        .arrow-down {
          width: 12px;
          height: 12px;
          fill: #e6e9ed;
        }
      }

      /deep/ .van-cell__title {
        margin-right: 12px;
        padding-right: 12px;
      }

      /deep/ .van-field__control {
        font-size: 16px;
      }

      .agreement {
        display: flex;
        align-items: center;
        margin: 0 0 24px;

        .agreement-icon {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          cursor: pointer;
          margin-right: 4px;
        }

        .agreement-box {
          color: #989fad;
          display: flex;
          font-size: 12px;

          .agreement-content {
            cursor: pointer;
            color: #00e3f9;
          }
        }
      }
    }
  }
}

.columns-pop {
  .columns-ul {
    height: 21.5625rem;
    overflow-y: auto;
    color: #e6e9ed;

    li {
      font-size: 1rem;
      height: 3.25rem;
      padding: 0 1rem;
      display: flex;
      align-items: center;
      cursor: pointer;

      &.select {
        color: #00e3f9;
      }
    }
  }
}

.code-pop.center {
  padding: 32px;
  width: 400px;

  /deep/ .title {
    height: auto;
    margin-bottom: 32px;
    color: #e6e9ed;
    font-size: 20px;
  }

  .off-img {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }

  .from-box {
    padding: 0;
  }

  .code-retry {
    display: flex;
    align-items: center;

    .van-cell {
      height: 56px;
      margin: 0;
      border: 1px solid #001235;
      background: #001235;
      color: #989fad;
      border-radius: 8px;

      /deep/ .van-field__control {
        font-size: 16px;
      }
    }

    .image {
      flex-shrink: 0;
      margin-left: 24px;
      height: 32px !important;
    }
  }

  .btn-box {
    margin-top: 32px;
    display: flex;
    align-items: center;

    .btns {
      flex: 1;
      height: 48px;
      font-size: 18px;

      &:first-child {
        color: #e6e9ed !important;
        margin-right: 32px;
      }
    }
  }

  /deep/ .van-button--info {
    border: none;
    font-size: 1.125rem;
    font-weight: bold;
    color: #001235 !important;
  }
}

.focus {
  border-color: #00e3f9 !important;
}
@media screen and (max-width: 768px) {
  .top-show {
    display: block;
  }
  .login {
    background: #001235;
    overflow: visible;
    height: auto;
    min-height: 100%;
    position: relative;

    .bg {
      display: none;
    }
  }
  .w-1200 {
    width: auto;
    height: auto;
    margin: 0 auto;
    display: block;
    overflow: hidden;

    .logo {
      display: block;
      width: 7.6875rem;
      margin: 7.0625rem auto;
    }

    .log-pc {
      display: none;
    }
  }

  .card {
    width: auto;
    height: auto;
    border-radius: 0;

    .transition-box {
      padding: 0 1.5rem;

      .back-img {
        display: none;
      }

      .title-top {
        font-size: 1.5rem;
      }

      .reacquire {
        margin: 0.75rem 0 1.5rem;
        font-size: 0.875rem;
      }

      .security {
        /deep/ .security-code-container {
          .field-wrap {
            font-size: 1.25rem;
            width: 2.75rem;
            height: 2.75rem;
            background: #002748;
            border-color: #00e3f9;

            &.cursor {
              &::after {
                width: 0.125rem;
              }
            }
          }
        }
      }

      .log-btn {
        height: 3rem;
        font-size: 1.125rem;
      }

      .title-prompt {
        font-size: 1rem;
        margin: 0.75rem 0 1.5rem;
      }

      .form-absolute {
        margin-top: 1.5rem;

        .van-cell {
          background: #002748;
          border-color: #0085a0;
          height: 3.25rem;
          font-size: 1rem;
        }

        .columns-code {
          color: #e6e9ed;

          .arrow-down {
            width: 0.75rem;
            height: 0.75rem;
          }
        }

        /deep/ .van-cell__title {
          margin-right: 0.75rem;
          padding-right: 0.75rem;
        }

        /deep/ .van-field__control {
          font-size: 1rem;
        }

        .agreement {
          .agreement-icon {
            width: 1rem;
            height: 1rem;
            margin-right: 0.25rem;
          }

          .agreement-box {
            font-size: 0.75rem;

            .agreement-content {
              color: #00e3f9;
            }
          }
        }
      }
    }
  }

  .code-pop.center {
    padding: 1.5rem 1rem 1rem;
    width: 17.5rem;

    /deep/ .title {
      font-size: 1.125rem;
      margin-bottom: 1rem;
    }

    .off-img {
      display: none;
    }

    .code-retry {
      .van-cell {
        height: 2.75rem;
        border: 1px solid rgba(0, 227, 249, 0.5);
        background: #002748;
        border-radius: 0.5rem;

        /deep/ .van-field__control {
          font-size: 1rem;
        }
      }

      .image {
        margin-left: 0.75rem;
        height: 1.75rem !important;
      }
    }

    .btn-box {
      margin-top: 1.5rem;

      .btns {
        height: 2.75rem;
        font-size: 1rem;

        &:first-child {
          margin-right: 1rem;
        }
      }
    }

    /deep/ .van-button--info {
      border: none;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue